import { b as __awaiter, c as __generator, _ as _assign } from '../../tslib.es6-c6da0ae6.js';
import React from 'react';
import AnalyticsService from '@picsart/rc/services/analytics';
import getBrowserVersion from '../../getBrowserVersion/index.js';
import getBrowserName from '../../getBrowserName/index.js';
import getDevice from '../../getDevice/index.js';
import isDev from '../../isDev/index.js';
import getOS from '../../getOsName/index.js';

var scopeType;
(function (scopeType) {
  scopeType["monetization"] = "monetization";
  scopeType["marketplace"] = "marketplace";
  scopeType["growth"] = "growth";
  scopeType["editor"] = "editor";
  scopeType["miniapps"] = "miniapps";
  scopeType["other"] = "other";
})(scopeType || (scopeType = {}));
var bugsnagStagesEnum;
(function (bugsnagStagesEnum) {
  bugsnagStagesEnum["preproduction"] = "preproduction";
  bugsnagStagesEnum["development"] = "development";
  bugsnagStagesEnum["per-branch"] = "per-branch";
  bugsnagStagesEnum["production"] = "production";
  bugsnagStagesEnum["miniapp_name_stage"] = "miniapp_name_stage";
  bugsnagStagesEnum["undefined_stage"] = "undefined_stage";
})(bugsnagStagesEnum || (bugsnagStagesEnum = {}));
var BUGSNAG_STATUSES;
(function (BUGSNAG_STATUSES) {
  BUGSNAG_STATUSES["ERROR"] = "error";
  BUGSNAG_STATUSES["DEBUG"] = "debug";
  BUGSNAG_STATUSES["INFO"] = "info";
  BUGSNAG_STATUSES["WARN"] = "warn";
  BUGSNAG_STATUSES["TRACE"] = "trace";
  BUGSNAG_STATUSES["LOG"] = "log";
})(BUGSNAG_STATUSES || (BUGSNAG_STATUSES = {}));
var excludedErrors = ['fbq is not defined', "can't find variable: fbq"];
var GENERAL_METADATA_SECTION = 'general';
var fierAnalyticsCrashWebEvent = function fierAnalyticsCrashWebEvent(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var appVersion = _a.appVersion,
    project = _a.project,
    scope = _a.scope,
    releaseStage = _a.releaseStage,
    event = _a.event;
  var is_mobile = getDevice().isMobile;
  if (excludedErrors.includes((_b = event === null || event === void 0 ? void 0 : event.originalError) === null || _b === void 0 ? void 0 : _b.message)) {
    return undefined;
  }
  var analyticsData = {
    project_version: appVersion,
    device: {
      id: (_c = event === null || event === void 0 ? void 0 : event.device) === null || _c === void 0 ? void 0 : _c.id,
      locale: (_d = event === null || event === void 0 ? void 0 : event.device) === null || _d === void 0 ? void 0 : _d.locale,
      orientation: (_e = event === null || event === void 0 ? void 0 : event.device) === null || _e === void 0 ? void 0 : _e.orientation,
      time: (_f = event === null || event === void 0 ? void 0 : event.device) === null || _f === void 0 ? void 0 : _f.time,
      userAgent: (_g = event === null || event === void 0 ? void 0 : event.device) === null || _g === void 0 ? void 0 : _g.userAgent,
      browserName: getBrowserName((_j = (_h = event === null || event === void 0 ? void 0 : event.device) === null || _h === void 0 ? void 0 : _h.userAgent) === null || _j === void 0 ? void 0 : _j.toLowerCase()),
      browserVersion: getBrowserVersion((_k = event === null || event === void 0 ? void 0 : event.device) === null || _k === void 0 ? void 0 : _k.userAgent),
      osName: getOS((_l = event === null || event === void 0 ? void 0 : event.device) === null || _l === void 0 ? void 0 : _l.userAgent)
    },
    scope: scope,
    project: project,
    stage: releaseStage === null || releaseStage === void 0 ? void 0 : releaseStage.replace('-', '_'),
    url: event === null || event === void 0 ? void 0 : event.request,
    is_mobile: is_mobile,
    stackTrace: event === null || event === void 0 ? void 0 : event.originalError,
    crash_message: (_m = event === null || event === void 0 ? void 0 : event.originalError) === null || _m === void 0 ? void 0 : _m.message,
    error_type: ((_o = event === null || event === void 0 ? void 0 : event.errors[0]) === null || _o === void 0 ? void 0 : _o.errorClass) || 'UnknownError',
    unhandled: event === null || event === void 0 ? void 0 : event.unhandled
  };
  try {
    AnalyticsService === null || AnalyticsService === void 0 ? void 0 : AnalyticsService.sendEvent('crash_web', analyticsData);
  } catch (_p) {
    console.log('CAN NOT SEND EVENT TO INTERNAL ANALYTICS', analyticsData.crash_message, analyticsData);
  }
};
var onErrorCallBack = function onErrorCallBack(_a) {
  var appVersion = _a.appVersion,
    project = _a.project,
    scope = _a.scope,
    releaseStage = _a.releaseStage;
  return function (event) {
    var _a, _b, _c;
    (_a = ErrorLogger.resetEventCount) === null || _a === void 0 ? void 0 : _a.call(ErrorLogger);
    event === null || event === void 0 ? void 0 : event.addMetadata(GENERAL_METADATA_SECTION, {
      paa_did: (_c = (_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.getItem('paa_did')) !== null && _c !== void 0 ? _c : ''
    });
    fierAnalyticsCrashWebEvent({
      appVersion: appVersion,
      project: project,
      scope: scope,
      releaseStage: releaseStage,
      event: event
    });
  };
};
var ErrorLogger = function () {
  function ErrorLogger() {
    this.bugsnagClient = null;
    this.beforeInitMetaData = {};
  }
  ErrorLogger.prototype.init = function (props) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
      var _e, _f, releaseStage, _g, apiKey, appVersion, _h, project, _j, scope, metaData, Bugsnag, BugsnagPluginReact, getGeoZone;
      return __generator(this, function (_k) {
        switch (_k.label) {
          case 0:
            bugsnagStagesEnum[bugsnagStagesEnum.miniapp_name_stage] = props === null || props === void 0 ? void 0 : props.releaseStage;
            _e = props !== null && props !== void 0 ? props : {}, _f = _e.releaseStage, releaseStage = _f === void 0 ? process.env.REACT_APP_BUGSNAG_ENV || bugsnagStagesEnum.undefined_stage : _f, _g = _e.apiKey, apiKey = _g === void 0 ? process.env.REACT_APP_BUGSNAG_API_KEY || null : _g, appVersion = _e.appVersion, _h = _e.project, project = _h === void 0 ? 'undefined_project' : _h, _j = _e.scope, scope = _j === void 0 ? scopeType.other : _j, metaData = _e.metaData;
            if (!apiKey) return [3, 5];
            this.bugsnagOnErrorConfig = {
              appVersion: appVersion,
              project: project,
              scope: scope,
              releaseStage: releaseStage
            };
            return [4, import('../../bugsnag-7e313460.js').then(function (n) { return n.b; })];
          case 1:
            Bugsnag = _k.sent()["default"];
            return [4, import('@bugsnag/plugin-react')];
          case 2:
            BugsnagPluginReact = _k.sent()["default"];
            return [4, import('../getGeoZone/index.js')];
          case 3:
            return [4, (_b = (_a = _k.sent())["default"]) === null || _b === void 0 ? void 0 : _b.call(_a)];
          case 4:
            getGeoZone = _k.sent();
            ErrorLogger.resetEventCount = Bugsnag === null || Bugsnag === void 0 ? void 0 : Bugsnag.resetEventCount;
            this.bugsnagClient = Bugsnag.start({
              apiKey: apiKey,
              plugins: [new BugsnagPluginReact()],
              appVersion: appVersion,
              releaseStage: releaseStage,
              enabledReleaseStages: Object.keys(bugsnagStagesEnum),
              maxEvents: 100,
              maxBreadcrumbs: 100,
              onError: onErrorCallBack(this.bugsnagOnErrorConfig)
            });
            this.addMetadata(_assign(_assign({
              scope: scope,
              project: project,
              paa_did: (_d = (_c = window === null || window === void 0 ? void 0 : window.localStorage) === null || _c === void 0 ? void 0 : _c.getItem('paa_did')) !== null && _d !== void 0 ? _d : '',
              countryCode: getGeoZone === null || getGeoZone === void 0 ? void 0 : getGeoZone.country_code
            }, metaData), this.beforeInitMetaData));
            this.beforeInitMetaData = {};
            _k.label = 5;
          case 5:
            return [2];
        }
      });
    });
  };
  ErrorLogger.prototype.getErrorBoundary = function () {
    var bugsnagClient = this.bugsnagClient;
    return function getErrorBoundary(_a) {
      var _b;
      var children = _a.children;
      if (bugsnagClient) {
        var ErrorBoundary = (_b = bugsnagClient.getPlugin('react')) === null || _b === void 0 ? void 0 : _b.createErrorBoundary(React);
        return /*#__PURE__*/React.createElement(ErrorBoundary, null, children);
      }
      return children;
    };
  };
  ErrorLogger.prototype.trigger = function (error, status) {
    if (status === void 0) {
      status = BUGSNAG_STATUSES.LOG;
    }
    if (isDev) {
      console[status](error);
    }
    if (this.bugsnagClient && [BUGSNAG_STATUSES.ERROR, BUGSNAG_STATUSES.WARN].includes(status)) {
      this.bugsnagClient.notify(error, undefined, function (err) {
        if (err) {
          console.error("ANALYTICS_EVENT Failed to send report because of:\n".concat(err.stack));
        }
      });
    }
  };
  ErrorLogger.prototype.setUser = function (user) {
    if (!this.bugsnagClient) return;
    this.bugsnagClient.setUser(String(user.id), user.email, user.name);
  };
  ErrorLogger.prototype.leaveBreadcrumb = function (message, metadata, type) {
    if (!this.bugsnagClient) return;
    this.bugsnagClient.leaveBreadcrumb(message, metadata, type);
  };
  ErrorLogger.prototype.addMetadata = function (values) {
    if (!this.bugsnagClient) {
      this.beforeInitMetaData = _assign(_assign({}, this.beforeInitMetaData), values);
    } else {
      this.bugsnagClient.addMetadata(GENERAL_METADATA_SECTION, values);
    }
  };
  return ErrorLogger;
}();
var errorLogger = new ErrorLogger();

export { BUGSNAG_STATUSES, bugsnagStagesEnum, errorLogger as default, excludedErrors, scopeType };
//# sourceMappingURL=index.js.map
